import { observer } from 'mobx-react-lite';

import Loader from 'src/components/common/loader';
import Button from 'src/components/ui/button';
import CatalogSection from '../catalog-section';

import catalogStore from 'src/stores/catalog-store';
import globalStore from 'src/stores/global-store';
import popupStore from 'src/stores/popup-store';

import {
  ApiRoute,
  GoogleAnalyticsButton,
  GoogleAnalyticsPage,
  LOCALES,
  PopupName,
} from 'src/constants';
import { getGoogleAnalyticsEvent } from 'src/utils';
import type { CatalogListProps } from './catalog-list.props';

import './catalog-list.scss';

const CatalogList = observer(({ setCategoryRef }: CatalogListProps) => {
  const {
    loadingState: { [ApiRoute.ITEMS]: isLoading },
    categoriesWithItems,
  } = catalogStore;
  const { deceasedId } = globalStore;

  const handlePopupContactClick = () => {
    popupStore.showPopup(PopupName.CONTACT, { deceasedId });
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="catalog-list">
      {categoriesWithItems.map((categoryData) => {
        return (
          <CatalogSection
            key={categoryData.category}
            categoryData={categoryData}
            setCategoryRef={setCategoryRef}
          />
        );
      })}
      <div className="catalog-list__contacts">
        {LOCALES.IF_YOU_HAVE_QUESTION}
        <Button
          analyticsEvent={getGoogleAnalyticsEvent(
            GoogleAnalyticsPage.SERVICES,
            GoogleAnalyticsButton.CONTACT_CEMETERY
          )}
          className="catalog-list__contacts-button"
          label={LOCALES.CONTACT_CEMETERY}
          onClick={handlePopupContactClick}
          size="oversize"
          theme="outlined"
        />
      </div>
    </div>
  );
});

export default CatalogList;
